import { render, staticRenderFns } from "./GettingStarted.vue?vue&type=template&id=97b4ada6"
import script from "./GettingStarted.vue?vue&type=script&lang=ts"
export * from "./GettingStarted.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports